<template>
  <content>
    <publisher-details-card :details="details"></publisher-details-card>
    <div class="my-3">
      <b-btn v-if="isAdmin" :exact="true"
             :to="{ name: 'PublisherSettings', params: { cid: companyId } }" variant="primary">
        Publisher Settings
      </b-btn>
    </div>

    <table-card
      sort-by="name"
      :fields="tableFields"
      :items="mediums"
      @show-details="loadTags"
      class="tr-cursor-pointer">
      <template v-slot:cell(title)>
        <span class="h4 align-text-bottom mx-1 text-primary icon-Mediums icon"/>
        Mediums
      </template>
      <template v-slot:cell(type)="data">
        <span class="h4 text-medium dark-when-details icon"
              :class="{ 'icon-Desktop': data.value === 'SITE', 'icon-Mobile': data.value === 'APP' }">
        </span>
      </template>
      <template v-slot:cell(actions)="data">
        <div class="hidden-button-group float-right">
          <icon-button @click.stop :to="{ name: 'PublisherZoneSettings', params: {cid: companyId, mid: data.item.id}}" class="mr-2"
                       icon="icon-Add_Circle" variant="outline-border" tooltip="New Zone"></icon-button>
          <icon-button @click.stop
                       :to="{ name: 'PublisherMediumSettings', params: {cid: companyId, mid: data.item.id}}"
                       class="mr-2" icon="icon-Settings" variant="outline-border" tooltip="Settings"></icon-button>
          <icon-button class="mr-2" small icon="fas fa-align-justify mb-0" variant="outline-border"
                       :to="{ name: 'PublisherAdsTxt', params: {cid: companyId, mid: data.item.id }}"
                       tooltip="Ads.txt Entries">aaa
          </icon-button>
          <!--
          <icon-button @click.stop icon="icon-Report" variant="outline-border" tooltip="Report"></icon-button>
          -->
        </div>
      </template>
      <template v-slot:row-details="row">
        <div class="small">
          <template v-if="!tags[row.item.id]">
            <hr class="border-border m-0 table-hr"/>
            <h4 class="text-muted p-3">Loading.. </h4>
          </template>
          <template v-else-if="tags[row.item.id] && !tags[row.item.id].length">
            <hr class="border-border m-0 table-hr"/>
            <h4 class="text-info p-3 ml-5 pl-5">
              No tag zones created yet
            </h4>
          </template>
          <div v-else v-for="tag in tags[row.item.id]" :key="tag.id">
            <hr class="border-border m-0 table-hr"/>
            <div class="ml-5 pl-5 d-inline-flex sub-hidden-button-holder">
              <b-table
                small
                thead-tr-class="text-muted small text-uppercase"
                tbody-tr-class="text-black"
                :hover="false"
                class="tag-table no-hover my-2"
                :fields="detailsFields"
                :items="[ tag ]">
                <template v-slot:cell(pos)="data">
                  {{ data.item.pos | capitalizeFirst }}
                </template>
              </b-table>
              <div class="sub-hidden-button-group  my-auto">
                <icon-button class="mr-2 small" icon="icon-Settings" variant="outline-border"
                             :to="{ name: 'PublisherZoneSettings', params: {cid: tag.company_id, mid: tag.med_id, zid: tag.id}}"
                             tooltip="Settings">
                </icon-button>
                <icon-button class="mr-2" small icon="icon-Desktop" variant="outline-border"
                             :to="{ name: 'TagIntegrationCode', params: {cid: tag.company_id, mid: tag.med_id, zid: tag.id}}"
                             tooltip="Integration Code">
                </icon-button>
                <icon-button class="small" icon="icon-Report" variant="outline-border" tooltip="Report"></icon-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </table-card>
    <div class="row text-left">
      <div class="col-sm">
        <b-btn variant="primary" class="my-3 mx-0"
               :to="{ name: 'PublisherMediumSettings', params: {cid: companyId, mid: 'new'}}">
          New Property
        </b-btn>
      </div>
    </div>

  </content>
</template>
<script>
    import {PublisherApi} from '@/publisher/api'
    import preRouteDataFetcher from '@/mixins/preRouteDataFetcher'
    import TableCard from '@/components/TableCard'
    import PublisherDetailsCard from '@/publisher/components/PublisherDetailsCard'
    import auth from '@/auth'

    export default {
        props: {
            cid: {required: false}
        },
        created () {
            PublisherApi.listPublisherMediums(this.getCompanyId()).then((list) => {
                this.mediums = list
            })
            PublisherApi.publisherDetails(this.getCompanyId()).then((pub) => {
                this.details = pub
            })
        },
        data() {
            return {
                mediums: [],
                details: {},
                tags: {}, /* map of cached mediumId: [tags] api resp */
                tableFields: [
                    {key: 'row-details', label: ''},
                    {key: 'type', label: ''},
                    {key: 'name', label: 'Medium Name', tdClass: 'majorField'},
                    {key: 'id', tdClass: 'text-muted minorField'},
                    {key: 'domain', tdClass: 'text-muted minorField'},
                    {key: 'actions', label: ''}
                ],
                detailsFields: [
                    {key: 'name', label: 'Zone Name', tdClass: 'boldish'},
                    {key: 'id',},
                    {key: 'pos', label: 'Ad Position'},
                    {key: 'bidfloor', label: 'Floor Value'},
                ],
                form: {cats: []},
                loading: false,
            }
        },
        methods: {
            getCompanyId() {
                return this.cid ? this.cid : auth.details().company_id
            },
            create() {
                this.form.masterId = this.publisherId
                this.$api.createPublisherMedium(this.form, (data) => {
                    this.form = data.medium
                    this.mediums.push(data.medium)
                })
            },
            loadTags(data) {
                let medId = data.id

                if (this.tags[medId]) {
                    return
                }

                PublisherApi.listPublisherTags(this.companyId, medId).then((list) => {
                    this.$set(this.tags, medId, list)
                })
            }
        },
        computed: {
            isAdmin() {
                return auth.isAdmin()
            },
            companyId () { return this.getCompanyId() }
        },
        filters: {
            capitalizeFirst(str) {
                let lower = str.toLowerCase()
                return lower.charAt(0).toUpperCase() + lower.substr(1)
            }
        },
        components: {
            TableCard,
            PublisherDetailsCard
        }
    }
</script>

<style>
  .table-hr {
    position: relative;
    top: -1px;
  }

  .sub-hidden-button-group {
    min-width: 140px;
  }

  .sub-hidden-button-holder:hover .sub-hidden-button-group {
    visibility: visible;
  }

  .table-card-wrapper .b-table-has-details .icon.dark-when-details {
    color: var(--black) !important;
  }

  .table-card-wrapper .boldish {
    font-weight: 500;
  }

  .table-card-wrapper .no-hover *:hover:not(.btn):not(.icon) {
    background-color: initial !important;
    cursor: initial !important;
  }

  .table-card-wrapper .tr-cursor-pointer tbody tr:hover:not(.b-table-details) {
    cursor: pointer !important;
  }

  .table-card-wrapper .tag-table {
    table-layout: fixed;
  }

  .table-card-wrapper .tag-table th, .tag-table td {
    border: 0px !important;
    padding: .1rem !important;
  }

  .table-card-wrapper .tag-table th {
    font-weight: 500 !important;
  }
</style>



// WEBPACK FOOTER //
// src/publisher/pages/PublisherMediums.vue